fragment WfFieldFragment on FormField {
    id
    type
    inputName
    fieldName
    attribute {
        id
    }
    entityName
    isIgnored
    needsMapping
    exampleValues {
        all {
            ... on EntityAttributeValueString {
                value
            }
        }
    }
}
